import React, { useState } from "react";
import styles from "./AudioGuidePlayer.css"
import Svg from "../../Svg/Svg"
import { Icon } from "../../../constants/consts-types"

const AudioGuidePlayer = ({setData, category, title, url}) => {

  const [closing, setClosing] = useState(false)

  const close = () => {
    setClosing(true)
    setTimeout(() => {
      setData()
    }, 400) // To await animation - should match css
  }

  return (

    <div className={`${styles.PlayerOverlay} ${closing && styles.animateOut}`}>
      <button
        onClick={close}
        type="button"
        className={styles.closePlayerOverlay}
      >
        <Svg id={Icon.CLOSE} />
      </button>
      <div className={styles.category} dangerouslySetInnerHTML={{__html: category}} />
      <div className={styles.title} dangerouslySetInnerHTML={{__html: title}} />
      <audio controls autoPlay src={url} />
    </div>
  )
}

export default AudioGuidePlayer


// WEBPACK FOOTER //
// ./src/components/AudioGuideComponents/AudioGuidePlayer/AudioGuidePlayer.js